import type { ReferenceUniverseListEntry } from "@eu.mdotm.api/sphere";
import { aclByArea, roleByArea } from "$root/functional-areas/acl/checkers/all";
import { validateACLPermissions } from "$root/functional-areas/acl/checkers/shared";
import { getCurrentUser } from "$root/functional-areas/user";
import type { ValidationResult } from "../common/types";
import type { UniverseActionUnavailableReason, UniverseListAction } from "./types";

export const universeListActionValidators: Record<
	UniverseListAction,
	(universe: ReferenceUniverseListEntry) => ValidationResult<UniverseActionUnavailableReason>
> = {
	delete(universe) {
		const user = getCurrentUser();

		if (!aclByArea.universe.canDelete(user.id, universe.richAcl?.acl ?? [])) {
			return [false, "ACL_EDITOR_REQUIRED"];
		}

		if ((universe.referralInvestments ?? []).length > 0) {
			return [false, "LINKED_TO_PORTFOLIO"];
		}

		return [true, undefined];
	},
	share(universe) {
		const user = getCurrentUser();

		if (!universe.richAcl?.acl) {
			return [false, "ACL_EDITOR_REQUIRED"];
		}

		if (!validateACLPermissions(user.id, universe.richAcl.acl, roleByArea.universe.OWNER)) {
			return [false, "ACL_OWNER_REQUIRED"];
		}

		return [true, undefined];
	},
	export(universe) {
		if (universe.universeType === "GROUP_UNIVERSE") {
			return [false, "GROUP_UNIVERSE"];
		}

		return [true, undefined];
	},
};
